<template>
  <div id="allCheckSeal">
    <div class="search">
      <el-form ref="dialogfref" :model="dialogform" label-width="96px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="申请人" prop="ApplicantName">
              <el-input
                v-model="dialogform.ApplicantName"
                placeholder="请输入要查找的申请人姓名"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="录入人" prop="PostName">
              <el-input
                v-model="dialogform.PostName"
                placeholder="请输入要查找的录入人姓名"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="申请时间">
              <el-date-picker
                style="width: 100%"
                v-model="dialogform.StartTime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item>
              <el-date-picker
                style="width: 100%"
                v-model="dialogform.EndTime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="用章类型" prop="SealType">
              <el-select
                v-model="dialogform.SealType"
                placeholder="请选择用章类型"
                clearable
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="用章申请状态" prop="Status">
              <el-select
                v-model="dialogform.Status"
                clearable
                placeholder="请选择用章申请状态"
              >
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label-width="0">
              <div class="btn">
                <el-button type="primary" @click="searchseal()">搜索</el-button>
                <el-button @click="reset('dialogfref')">重置</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="applicantName" label="申请人姓名">
        </el-table-column>
        <el-table-column prop="reason" label="申请事由"> </el-table-column>
        <el-table-column prop="sealType" label="用章类型" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.sealType == 'contract_seal'">合同章</span>
            <span v-if="scope.row.sealType == 'corporate_seal'">法人章</span>
            <span v-if="scope.row.sealType == 'official_seal'">公章</span>
            <span v-if="scope.row.sealType == 'official_corporate_seal'"
              >公章+法人章</span
            >
            <span v-if="scope.row.sealType == 'contract_corporate_seal'"
              >合同章+法人章</span
            >
            <span v-if="scope.row.sealType == 'law_seal'"
              >法律意见书专用章</span
            >
            <span v-if="scope.row.sealType == 'legal_letter_seal'"
              >律师函专用章</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="postTime" label="申请时间">
          <template slot-scope="scope">
            {{ handleTime(scope.row.postTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
              prop="sealtime"
              label="用印时间">
            </el-table-column> -->
        <el-table-column label="当前状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" type="text" class="spz"
              >审批中</span
            >
            <span
              v-if="scope.row.result == 1 && scope.row.status == 0"
              type="text"
              class="fail"
              >被驳回</span
            >
            <span
              v-if="scope.row.result == 0 && scope.row.status == 0"
              type="text"
              class="pass"
              >通过</span
            >
            <!-- <span v-if="scope.row.status==-1" type="text" class="del">已撤回</span> -->
            <span v-if="scope.row.status == -1" type="text" class="del"
              >已撤销</span
            >
            <!-- <span v-if="scope.row.status==2" type="text" class="del">已取消</span> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">
            <!-- <el-button
              class="look"
              size="small"
              @click="Look(scope.row.id)"
              v-if="$store.state.rolesname.includes('AllSeal_look')"
              >查看</el-button
            > -->

            <el-button class="look" size="small" @click="Look(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
      <el-form ref="dialogfref" :model="dialogform" label-width="96px">
        <el-form-item label="申请人" prop="ApplicantName">
          <el-input
            v-model="dialogform.ApplicantName"
            placeholder="请输入要查找的申请人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="录入人" prop="PostName">
          <el-input
            v-model="dialogform.PostName"
            placeholder="请输入要查找的录入人姓名"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请时间">
              <el-date-picker
                style="width: 100%"
                v-model="dialogform.StartTime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-date-picker
                style="width: 100%"
                v-model="dialogform.EndTime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用章类型" prop="SealType">
          <el-select v-model="dialogform.SealType" placeholder="请选择用章类型">
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章申请状态" prop="Status">
          <el-select
            v-model="dialogform.Status"
            placeholder="请选择用章申请状态"
          >
            <el-option
              v-for="item in Status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0">
          <div class="btn">
            <el-button type="primary" @click="searchseal()">搜索</el-button>
            <el-button @click="reset('dialogfref')">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  
<script>
import { Seal, SealDel, allCheckSeal } from '../../api/seal'
export default {
  name: 'allCheckSeal',
  data() {
    return {
      // next: true,//是否是三级菜单,
      next: false, //是否是三级菜单
      Con: '',
      more: '',

      dialogVisible: false,
      form: {
        name: '',
        status: '',
        starttime: '',
        endtime: '',
        type: '破产案件',
        invoice: 0,
        closecase: 0,
        file: 0
      },
      dialogform: {
        ApplicantName: '',
        PostName: '',
        SealType: '',
        Status: null,
        StartTime: null,
        EndTime: null
      },
      Status: [
        { label: '已通过', value: 0 },
        { label: '待审核', value: 1 },
        { label: '被驳回', value: 2 }
        // { label: '已撤销', value: 4 }
      ],
      // { label: "已删除", value: -1 }],

      dialogVisible: false, //弹出框
      // IsorNo:[{ label: "是", value: 0 }, { label: "否", value: 1 }],
      // Casetype:[{ label: "民事案件", value: "民事案件" }, { label: "破产案件", value: "破产案件" }],
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章
      tableData: [],
      PageSizes: [5, 10, 20, 50],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false //只有一页的时候隐藏分页
    }
  },

  methods: {
    del(id, status) {
      this.$confirm('此操作将撤回申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          SealDel({ Id: id, Status: status }).then((res) => {
            if (res.data.status == 'success') {
              this.$message({
                type: 'success',
                message: '撤回成功!'
              })
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          })
        })
    },
    Look(id) {
      //查看
      this.$router.push({
        name: 'SealApprovedetail',
        path: '/home/seal/SealApprovedetail',
        query: {
          guid: id,
          dayin: false
        }
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },

    handleSizeChange(val) {
      this.PageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.search()
    },
    searchseal() {
      //搜索按钮
      this.PageIndex = 1
      this.search()
    },
    search() {
      //获取数据
      var starttime = null
      var endtime = null
      if (this.dialogform.StartTime) {
        starttime = this.JsonTime(this.dialogform.StartTime)
      }
      if (this.dialogform.EndTime) {
        endtime = this.JsonTime(this.dialogform.EndTime)
      }
      allCheckSeal({
        page: this.PageIndex,
        rows: this.PageSize,
        SealType: this.dialogform.SealType,
        ApplicantName: this.dialogform.ApplicantName,
        PostName: this.dialogform.PostName,
        Status: this.dialogform.Status,
        StartTime: starttime,
        EndTime: endtime,
        IsAll: true
      }).then((res) => {
        if (res.data.status == 'success') {
          // console.log(res.data.data)
          this.tableData = res.data.data
          this.Total = res.data.total
          this.dialogVisible = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    reset(form) {
      //重置更多选择
      this.dialogform.SealType = ''
      this.dialogform.ApplicantName = ''
      this.dialogform.PostName = ''
      this.dialogform.StartTime = null
      this.dialogform.EndTime = null
      this.dialogform.Status = null
      // this.search()
    },
    // change(){
    //   this.dialogform.ApplicantName=""
    // },
    getvalue() {
      //传值给父组件，
      //判断有没有审核权限，有的话该页面是三级页面，没有为二级页面
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/seal' //遍历每一个数组，过滤出返回值委true的值
      )
      var arr = target[0].children.filter(
        //查询审核权限
        (el) => el.path == 'SealApprove'
      )
      if (arr.length <= 0) {
        //没有用章审核权限
        this.next = false //该页面不为三级页面
      }
      // if(target[0].children[0].path!='SealApprove'){//没有用章审核权限
      //   this.next = false;//该页面不为三级页面
      // }
      this.$emit('value', this.next)
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    }
  },
  created() {
    this.getvalue()
    // if(this.$route.params.dialogform){//有值的话就是从详情页过来的
    //   this.PageSize = this.$route.params.PageSize //获取进入详情页前的筛选条件
    //   this.PageIndex = this.$route.params.PageIndex
    //   this.dialogform = this.$route.params.dialogform
    // }
    this.search()
    // console.log(this.$route.params.dialogform)
  }
}
</script>
  
<style lang="less" scoped>
// 查询
#allCheckSeal .search {
  box-sizing: border-box;
  width: 100%;
  // margin: auto;
  // display: flex;

  padding: 20px;
  // margin-bottom: 24px;
}

#allCheckSeal .search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

#allCheckSeal .nameSearch {
  width: 24vw;
  margin-right: 10px;
}

// #allCheckSeal .select {
//   width: 10vw;
//   margin-right: 10px;
// }

// 弹出框
#allCheckSeal /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

.btn {
  width: 100%;
  text-align: center;
}

//表格
#allCheckSeal .casestatus {
  color: rgba(254, 150, 74, 1);
}

#allCheckSeal .pass {
  color: #3077e6;
}

#allCheckSeal .spz {
  color: #0caf60;
}

#allCheckSeal .fail {
  color: #fe964a;
}

#allCheckSeal .del {
  color: red;
}

#allCheckSeal .look {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

#allCheckSeal .delbtn {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

// 分页
#allCheckSeal .bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

#allCheckSeal /deep/.el-pagination__total {
  float: left;
}

/deep/.el-pagination__sizes {
  float: left;
}
</style>
  